import { Injectable } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';
import { Toast, ToastType } from '../models/toast.model';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private toastSubject = new ReplaySubject<Toast>(1);
  private closeSubject = new Subject<string>();

  public readonly toasts$ = this.toastSubject.asObservable();
  public readonly close$ = this.closeSubject.asObservable();

  showSuccess(title: string, description: string, timeout = 5000, htmlContent = false): string {
    return this.show('success', title, description, timeout, htmlContent);
  }

  showWarning(title: string, description: string, timeout = 5000, htmlContent = false): string {
	return this.show('warning', title, description, timeout, htmlContent);
  }

  showError(title: string, description: string, timeout = 5000, htmlContent = false): string {
    return this.show('error', title, description, timeout, htmlContent);
  }

  private show(type: ToastType, title: string, description: string, timeout = 5000, htmlContent = false): string {
    const id = `toast-${crypto.randomUUID()}`;
    const toast: Toast = {
      id,
      type,
      title,
      description,
      htmlContent,
      timeout
    };

    this.toastSubject.next(toast);
    return id;
  }

  close(id: string): void {
    this.closeSubject.next(id);
  }
}
